<template>
    <div>Hello</div>
</template>

<script>
export default {
    name: 'Hello',
    components: {},
    props: {},
    data() {
        return {};
    },
    provide() { },
    inject: [],
    computed: {},
    watch: {},
    created() { },
    mounted() { },
    methods: {},
};
</script>

<style lang="scss" module></style>
